<script setup>
import { ref, computed, inject } from 'vue'
import * as PRODUCT from "../composables/useProducts"
import VLoadingIcon from "./VLoadingIcon.vue";
import useApp from "../composables/useApp";
import { useNotification } from "@kyvg/vue3-notification";
import { formSubmit } from '../composables/useTracking';

const route = inject('route');

const { notify } = useNotification();

const { debug } = useApp();

const props = defineProps({
    disabled: {
        type: Boolean,
        default: false,
    },

    data: {
        type: Object,
        required: true,
    },
})

const reminderData = computed(() => {
    let reminder = {
        product: props.data.product,
        type: props.data.type,
        petName: props.data.petName,
        date: props.data.product?.slug === PRODUCT.RECOMBITEK ? props.data.vaccinationDates?.[0] || null : props.data.date,
        vaccinationDates: props.data.product?.slug === PRODUCT.RECOMBITEK ? props.data.vaccinationDates : [],
        age: props.data.product?.slug === PRODUCT.RECOMBITEK ? {
            years: props.data.ageYears?.id ?? null,
            months: props.data.ageMonths?.id ?? null,
        } : null,
        specialComments: props.data.specialComments,
        dosage: {
            // daily, monthly
            type: null,
            doseCount: null,
        },
        time: props.data.time || null,
        timezoneRaw: props.data.timezoneRaw || null,
    }

    let frequency = {
        [PRODUCT.NEXGARD_SPECTRA]: {
            id: "once per month",
            name: "Once per month",
            value: 1,
        },
        [PRODUCT.NEXGARD]: {
            id: "once per month",
            name: "Once per month",
            value: 1,
        },
        [PRODUCT.HEARTGARD]: {
            id: "once per month",
            name: "Once per month",
            value: 1,
        },
        [PRODUCT.NEXGARD_COMBO]: {
            id: "once per month",
            name: "Once per month",
            value: 1,
        },
        [PRODUCT.SENVELGO]: {
            id: "once",
            name: "Once",
            value: 1,
        },
        [PRODUCT.SEMINTRA]: {
            id: "once",
            name: "Once",
            value: 1,
        },
    }

    switch (props.data.product.slug) {
        case PRODUCT.SENVELGO:
            reminder.senvelgoCatWeight = props.data.senvelgoCatWeight || null;
            reminder.dosage.type = "daily"
            reminder.howOften = props.data?.howOften?.id || null;
            reminder.dosage.doseCount = Math.floor(450 / parseFloat(props.data.senvelgoCatWeight))
            break;
        case PRODUCT.PUREVAX:
            reminder.dosage.type = "exact"

            reminder.dosage.doseCount = 1;
            break;
        case PRODUCT.RECOMBITEK:
            reminder.dosage.type = "exact4"
            reminder.dosage.doseCount = props.data.vaccinationDates?.length || 4;
            break;
        case PRODUCT.SEMINTRA:
            reminder.dosage.type = "daily"

            reminder.howOften = props.data?.howOften?.id || null;
            reminder.dosage.doseCount = Math.round(120 / parseFloat(props.data?.dosage) / frequency[PRODUCT.SEMINTRA].value)
            break;
        case PRODUCT.NEXGARD:
            reminder.dosage.type = "monthly"

            reminder.dosage.doseCount = 12;
            break;
        case PRODUCT.NEXGARD_SPECTRA:
            reminder.dosage.type = "monthly"

            reminder.dosage.doseCount = 12;
            break;
        case PRODUCT.NEXGARD_COMBO:
            reminder.dosage.type = "monthly"

            reminder.dosage.doseCount = 12;
            break;
        case PRODUCT.HEARTGARD:
            reminder.dosage.type = "monthly"

            reminder.dosage.doseCount = 12;
            break;
        case PRODUCT.FRONTLINE_PLUS:
            reminder.dosage.type = "monthly"

            reminder.dosage.doseCount = 12;
            break;
    }
    return reminder
})

const loading = ref(false);

const setReminder = async () => {
    if (props.disabled) return;

    loading.value = true;

    formSubmit('product_reminder_generated: ' + props.data.product.slug);

    try {
        const request = await axios.post(route('reminder.save'), {
            data: reminderData.value,
        })
        const { data } = request;

        if (data.success) {
            window.location.href = route('pages.download')
        }

        loading.value = false;
    } catch (error) {
        notify({
            title: "Error",
            text: "Something went wrong. " + error.response.data.message,
            type: "error",
        });

        loading.value = false;
    }
}
</script>

<template>
    <p class="flex-1 min-w-full py-4" v-if="debug">
        {{ reminderData }}
    </p>

    <button type="button" @click="setReminder"
        :class="{ 'bg-bi-accent-green text-bi-dark-green': !disabled, 'bg-bi-gray-50 text-bi-white pointer-events-none': disabled }"
        class="inline-flex items-center rounded-md border border-transparent hover:opacity-90 px-6 py-3 text-lg font-bi-text-medium hover:text-white shadow-sm hover:bg-bi-dark-green focus:outline-none focus:ring-2 focus:ring-bi-accent-green focus:ring-offset-2">
        <v-loading-icon width="24" height="24" class="mr-2" v-if="loading"></v-loading-icon>
        {{ $t('form.generate') }}
    </button>
</template>
